import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';
import { ErrorMessage } from '../validation/validationError';
import { migrateCompetitiveExamMasterNameFormValidation, migrateCompetitiveExamSubjectFormValidation } from '../validation/Validation';
import { ZodError } from 'zod';

const MigrateCompetitiveExamSubject = () => {
    const authorizedAxios = generateAxiosInstance()

    const initialFormState = {
        newCompetitiveExamNameMasterId: '',
        newCompetitiveExamBookMasterId: '',
        oldCompetitiveExamNameMasterId: '',
        oldCompetitiveExamBookMasterId: '',
        oldCompetitiveExamSubjectMasterId: ''
    }
    const [examNameList, setExamNameList] = useState([])
    const [newBookList, setNewBookList] = useState([])
    const [oldBookList, setOldBookList] = useState([]);
    const [oldSubjectList, setOldSubjectList] = useState([])

    const [lessonData, setLessonData] = useState(initialFormState)

    const [error, setErrors] = useState([])


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getExamNameList();
    }, []);


    const getExamNameList = () => {
        const apiUrlForSyllabus = `/get-competitive-exam-names`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setExamNameList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleExamNameChange = (e, isOld) => {
        const { name, value } = e.target;
        if (isOld) {
            setLessonData((prevData) => {
                return {
                    ...prevData,
                    [name]: value,
                    oldCompetitiveExamBookMasterId: ''
                }
            })

            const apiUrl = `/get-competitive-exam-book-master?competitiveExamNameMasterId=${value}`;
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setOldBookList(response.data.data)
                })
                .catch(error => {
                    setOldBookList([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        } else {
            setLessonData((prevData) => {
                return {
                    ...prevData,
                    [name]: value,
                    newCompetitiveExamBookMasterId: ''
                }
            })

            const apiUrl = `/get-competitive-exam-book-master?competitiveExamNameMasterId=${value}`;
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setNewBookList(response.data.data)
                })
                .catch(error => {
                    setNewBookList([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }

        if (value.trim().length !== 0) {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const handleBookChange = async (e) => {
        const { name, value } = e.target;

        setLessonData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                oldCompetitiveExamSubjectMasterId: ''
            }
        });

        const apiUrl = `/get-competitive-exam-book-wise-subject?competitiveExamBookMasterId=${value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setOldSubjectList(response.data.result)
            })
            .catch(error => {
                setOldSubjectList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        setLessonData((prevData) => {
            return {
                ...prevData,
                [name]: value
            }
        })

        if (value.trim() !== '') {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }


    const migrateExamSubject = async () => {
        const apiUrl = `/migrate-competitive-exam-book-subject`;
        try {
            setLoading(true);
            await migrateCompetitiveExamSubjectFormValidation.parseAsync(lessonData);
            const response = await authorizedAxios.post(apiUrl, lessonData);
            setLessonData(initialFormState)
            getExamNameList();
            setNewBookList([]);
            setOldBookList([]);
            setOldSubjectList([]);
            lessonData(initialFormState);
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            if (error instanceof ZodError) {
                setErrors(error.errors); // Set validation errors
            } else {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            }
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Migrate Competitive Exam Subject</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-right-left"></i>Migrate Competitive Subject</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label for="oldCompetitiveExamNameMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Old Competitive Exam Name:</label>
                                                    <select class="form-select" aria-label="Default select example" name='oldCompetitiveExamNameMasterId' onChange={(e) => handleExamNameChange(e, true)} value={lessonData.oldCompetitiveExamNameMasterId}>
                                                        <option selected value={''} disabled>Select Old Competitive Exam Name</option>
                                                        {
                                                            examNameList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.examName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={error} field="oldCompetitiveExamNameMasterId" />
                                                </div>

                                                <div className="col-md-4">
                                                    <label for="oldCompetitiveExamBookMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Old Book:</label>
                                                    <select class="form-select" aria-label="Default select example" name='oldCompetitiveExamBookMasterId' onChange={handleBookChange} value={lessonData.oldCompetitiveExamBookMasterId}>
                                                        <option selected value={''} disabled>Select Book</option>
                                                        {
                                                            oldBookList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={error} field="oldCompetitiveExamBookMasterId" />
                                                </div>

                                                <div className="col-md-4">
                                                    <label for="oldCompetitiveExamSubjectMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='oldCompetitiveExamSubjectMasterId' onChange={handleInputChange} value={lessonData.oldCompetitiveExamSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            oldSubjectList?.map((subject) => {
                                                                return <option value={subject.subjectMasterDetails.id}>{subject.subjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={error} field="oldCompetitiveExamSubjectMasterId" />
                                                </div>
                                            </div>
                                            
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label for="newCompetitiveExamNameMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select New Competitive Exam Name:</label>
                                                    <select class="form-select" aria-label="Default select example" name='newCompetitiveExamNameMasterId' onChange={(e) => handleExamNameChange(e, false)} value={lessonData.newCompetitiveExamNameMasterId}>
                                                        <option selected value={''} disabled>Select New Competitive Exam Name</option>
                                                        {
                                                            examNameList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.examName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={error} field="newCompetitiveExamNameMasterId" />
                                                </div>
                                                <div className="col-md-4">
                                                    <label for="newCompetitiveExamBookMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select New Book:</label>
                                                    <select class="form-select" aria-label="Default select example" name='newCompetitiveExamBookMasterId' onChange={handleInputChange} value={lessonData.newCompetitiveExamBookMasterId}>
                                                        <option selected value={''} disabled>Select Book</option>
                                                        {
                                                            newBookList?.map((book) => {
                                                                return <option value={book.id}>{book.bookName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={error} field="newCompetitiveExamBookMasterId" />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={migrateExamSubject}>Migrate</button>
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setLessonData(initialFormState); setOldBookList([]); setNewBookList([]); setOldSubjectList([]); setErrors([]); }}>Reset</button>

                                                        {/* {editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateLesson} disabled={!editId}>Update</button>)} */}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default MigrateCompetitiveExamSubject;